import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

/**
 * Ações em lote sobre as novidades selecionadas: marcar revisada (pronta para envio), publicar
 * (com aviso no sino opcional), voltar a rascunho, marcar como interna e descartar.
 * @param {{ count: number, busy: boolean, onChangeStatus: Function, onClear: Function }} props
 *   onChangeStatus(status, notifyBell)
 */
function CatalogBulkBar({ count, busy, onChangeStatus, onClear }) {
  const [notifyBell, setNotifyBell] = useState(false);
  if (count === 0) return null;

  return (
    <Box
      sx={{
        px: 2, py: 1.25, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap',
        bgcolor: '#EEF2FF', borderBottom: '1px solid #DCE3FB',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {count} selecionada{count === 1 ? '' : 's'}
      </Typography>
      <Button size="small" onClick={onClear} disabled={busy}>Limpar</Button>
      <Box sx={{ flex: 1 }} />
      <FormControlLabel
        control={<Checkbox size="small" checked={notifyBell} onChange={(e) => setNotifyBell(e.target.checked)} />}
        label={<Typography variant="body2">Avisar no sino</Typography>}
        sx={{ mr: 0 }}
      />
      <Button size="small" variant="outlined" startIcon={<TaskAltOutlinedIcon />} disabled={busy} onClick={() => onChangeStatus('reviewed', false)}>
        Marcar revisado
      </Button>
      <Button size="small" variant="contained" startIcon={<PublicOutlinedIcon />} disabled={busy} onClick={() => onChangeStatus('published', notifyBell)}>
        Publicar
      </Button>
      <Button size="small" variant="outlined" startIcon={<EditNoteOutlinedIcon />} disabled={busy} onClick={() => onChangeStatus('draft', false)}>
        Voltar a rascunho
      </Button>
      <Button size="small" variant="outlined" color="inherit" startIcon={<LockOutlinedIcon />} disabled={busy} onClick={() => onChangeStatus('internal', false)}>
        Marcar interno
      </Button>
      <Button size="small" variant="outlined" color="error" startIcon={<DeleteOutlineIcon />} disabled={busy} onClick={() => onChangeStatus('discarded', false)}>
        Descartar
      </Button>
    </Box>
  );
}

export default CatalogBulkBar;
